export default function patchFetchForSentryTrace(Sentry) {
  console.log('[sentryTraceFetch] called, _patchedFetch:', window._patchedFetch);
  if (window._patchedFetch) {
	console.log('[sentryTraceFetch] fetch already patched, skipping');
	return;
  }
  // Save the original fetch
  const originalFetch = window.fetch;

  window.fetch = function (input, init = {}) {
	let url;

	if (typeof input === "string") {
	  url = input;
	} else if (Request && input instanceof Request || typeof input === "Request") {
	  url = input.url;
	} else {
	  throw new Error("Unsupported fetch input type");
	}

	const isSameOrigin = new URL(url, window.location.origin).origin === window.location.origin;

	if (isSameOrigin) {
	  init.headers = {
		...init.headers,
		"sentry-trace": window.SENTRY_TRACE,
		baggage: window.SENTRY_BAGAGGE,
	  };
	}

	return originalFetch(input, init);
  };

  window._patchedFetch = true;
  console.log('[sentryTraceFetch] fetch patched successfully');
}
